import { render, staticRenderFns } from "./PDAsao.vue?vue&type=template&id=d2aff8c0&scoped=true"
import script from "./PDAsao.vue?vue&type=script&lang=js"
export * from "./PDAsao.vue?vue&type=script&lang=js"
import style0 from "./PDAsao.vue?vue&type=style&index=0&id=d2aff8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aff8c0",
  null
  
)

export default component.exports